import React from 'react';
import { Route } from 'react-router-dom';
import Endpoints from '../datasource/endpoints';

//Lazy Loading
const LoginPage = React.lazy(() => import('./public/login/index.tsx'));
const RegisterPage = React.lazy(() => import('./public/registar/index.tsx'));
const Account = React.lazy(() => import('./conta'));
const ValidarEmailPage = React.lazy(() => import('./public/recuperarsenha/validaremail/index.tsx'));
const RecuperarSenhaPage = React.lazy(() => import('./public/recuperarsenha/index.tsx'));

const RedirecionarLogin = () => {
  window.location.href = Endpoints.verificarLoginRoute;
  return <></>;
};

const routes = (
  <>
    <Route path="/public/app/:app/login" element={<LoginPage />} index />
    <Route path="/public/app/:app/registrar" element={<RegisterPage />} />
    <Route path="/public/validaremail/:codigo" element={<ValidarEmailPage />} index />
    <Route path="/public/recuperarsenha/:codigo?" element={<RecuperarSenhaPage />} index />

    <Route path="/conta/*" element={<Account />} />

    <Route path="/" element={<RedirecionarLogin />} />
  </>
);

export default routes;
